import { AxiosResponse } from "axios";
import axios from "config/axios";
import { API } from "enums/API";
import { BillingStatus } from "enums/Billing";
import { IBilling, IBillingFilters, IBillingInClinic, IBillingLabFilters } from "interfaces/Billing";

class BillingService {
  getAll = (
    params: IBillingFilters,
    signal?: AbortSignal
  ): Promise<AxiosResponse<IBilling[]>> => {
    return axios.get(API.Billing, { params, signal });
  };

  getRTM = (
    params: IBillingFilters,
    signal?: AbortSignal
  ): Promise<AxiosResponse<IBilling[]>> => {
    return axios.get(API.BillingForClient, { params, signal });
  };

  getLab = (
    params: IBillingLabFilters,
    signal?: AbortSignal
  ): Promise<AxiosResponse<IBillingInClinic[]>> => {
    return axios.get(API.BillingLab, { params, signal });
  };

  update = (data: {
    transactionId: number;
    status: BillingStatus;
    comment?: string;
  }): Promise<AxiosResponse<void>> => {
    return axios.post(API.BillingStatusUpdate, data);
  };
}

export default new BillingService();
